import React from "react";

function XIcon() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="100%"
            height="100%"
            fill="none"
            viewBox="0 0 42 42"
        >
            <circle cx="21" cy="21" r="21" fill="#000"></circle>
            <g clipPath="url(#clip0_5_49273)">
                <path
                    fill="#fff"
                    d="M22.522 19.195L28.48 12h-1.412l-5.172 6.247L17.765 12H13l6.247 9.447L13 28.99h1.412l5.461-6.597 4.363 6.597H29l-6.478-9.796zM20.59 21.53l-.633-.94-5.036-7.486h2.168l4.064 6.04.633.941 5.283 7.852H24.9l-4.311-6.407z"
                ></path>
            </g>
            <defs>
                <clipPath id="clip0_5_49273">
                    <path
                        fill="#fff"
                        d="M0 0H16V17H0z"
                        transform="translate(13 12)"
                    ></path>
                </clipPath>
            </defs>
        </svg>
    );
}

export default XIcon;
